import {
  AmexIcon,
  DinersIcon,
  DiscoverIcon,
  JCBIcon,
  MCIcon,
  Props,
  UnknownIcon,
  VisaIcon,
} from '../components/icons/CreditCardIcons';

const CreditCardBrandMapping: Dictionary<{
  component(props: Props): JSX.Element;
  maskClass: string;
}> = {
  'American Express': {
    component: AmexIcon,
    maskClass: 'is-mask-one',
  },
  'Diners Club': {
    component: DinersIcon,
    maskClass: 'is-mask-one',
  },
  Discover: {
    component: DiscoverIcon,
    maskClass: 'is-mask-two',
  },
  Elo: {
    component: UnknownIcon,
    maskClass: 'is-mask-two',
  },
  JCB: {
    component: JCBIcon,
    maskClass: 'is-mask-two',
  },
  MasterCard: {
    component: MCIcon,
    maskClass: 'is-mask-two',
  },
  UnionPay: {
    component: UnknownIcon,
    maskClass: 'is-mask-two',
  },
  Unknown: {
    component: UnknownIcon,
    maskClass: 'is-mask-two',
  },
  Visa: {
    component: VisaIcon,
    maskClass: 'is-mask-two',
  },
};

export default CreditCardBrandMapping;
